










import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import RuleForm from './RuleForm.vue'
import addRuleMixin from './addRuleMixin'
import RulesApi from '@/api/rules'

@Component({
	name: 'addWPRule',
	components: {
		PageLayout,
		RuleForm,
	},
})
export default class RulesList extends Mixins(addRuleMixin) {
	private initialRule: any = null

	private getRuleDetail() {
		RulesApi.getRuleDetail(this.ruleId).then((res: any) => {
			this.initialRule = res.data
		})
	}

	public created() {
		this.companyId = this.$ls.get('editRuleCompanyId')
		this.ruleId = this.$ls.get('settingRuleId') || ''

		this.getRuleDetail()
	}
}
